import { render, staticRenderFns } from "./NegociacaoAlterarRespostaProdutos.vue?vue&type=template&id=0cf2ec2c"
import script from "./NegociacaoAlterarRespostaProdutos.vue?vue&type=script&lang=js"
export * from "./NegociacaoAlterarRespostaProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports